import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Modal from '../components/Modal';
import toast from 'react-hot-toast';
import { Plus, Edit2, Trash2, Search } from 'lucide-react';
import { formatCurrency } from '../utils/helpers';

const empty = { name:'', category_id:'', unit:'PCS', hsn_code:'', tax_rate:0, purchase_price:0, selling_price:0, stock_qty:0, min_stock:0, description:'', status:1 };

export default function Products() {
  const [list, setList] = useState([]);
  const [cats, setCats] = useState([]);
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => api.get('/products').then(r => setList(r.data.data || []));
  useEffect(() => {
    load();
    api.get('/categories').then(r => setCats(r.data.data || []));
  }, []);

  const save = async () => {
    if (!form.name) return toast.error('Name required');
    try {
      if (editId) await api.put('/products/' + editId, form);
      else await api.post('/products', form);
      toast.success('Saved');
      setOpen(false); setForm(empty); setEditId(null); load();
    } catch (e) { toast.error(e?.response?.data?.message || 'Error'); }
  };

  const del = async (id) => {
    if (!window.confirm('Delete product?')) return;
    try { await api.delete('/products/' + id); toast.success('Deleted'); load(); }
    catch (e) { toast.error(e?.response?.data?.message || 'Error'); }
  };

  const edit = (p) => { setForm({ ...empty, ...p }); setEditId(p.id); setOpen(true); };
  const filtered = list.filter(p => !q || p.name.toLowerCase().includes(q.toLowerCase()) || (p.product_code||'').toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="card">
      <div className="card-header">
        <h3>Products ({filtered.length})</h3>
        <button className="btn btn-blue" onClick={() => { setForm(empty); setEditId(null); setOpen(true); }}><Plus size={14}/> Add Product</button>
      </div>
      <div className="search-bar">
        <Search size={16} style={{color:'#94a3b8'}}/>
        <input placeholder="Search product..." value={q} onChange={e=>setQ(e.target.value)} />
      </div>
      <div className="table-wrap">
        <table>
          <thead><tr><th>Code</th><th>Name</th><th>Category</th><th>HSN</th><th>Unit</th><th className="td-num">Buy</th><th className="td-num">Sell</th><th className="td-num">Stock</th><th className="td-num">Min</th><th>Actions</th></tr></thead>
          <tbody>
            {filtered.length ? filtered.map(p => (
              <tr key={p.id}>
                <td><strong>{p.product_code}</strong></td>
                <td>{p.name}</td>
                <td>{p.category_name || '-'}</td>
                <td>{p.hsn_code || '-'}</td>
                <td>{p.unit}</td>
                <td className="td-num">{formatCurrency(p.purchase_price)}</td>
                <td className="td-num">{formatCurrency(p.selling_price)}</td>
                <td className={'td-num ' + (parseFloat(p.stock_qty) <= parseFloat(p.min_stock) ? 'text-red' : 'text-green')}>{p.stock_qty}</td>
                <td className="td-num">{p.min_stock}</td>
                <td>
                  <button className="btn btn-sm btn-gray" onClick={()=>edit(p)}><Edit2 size={12}/></button>{' '}
                  <button className="btn btn-sm btn-red" onClick={()=>del(p.id)}><Trash2 size={12}/></button>
                </td>
              </tr>
            )) : <tr><td colSpan="10" className="empty">No products</td></tr>}
          </tbody>
        </table>
      </div>

      <Modal open={open} onClose={()=>setOpen(false)} title={editId ? 'Edit Product' : 'Add Product'} size="lg"
        footer={<>
          <button className="btn btn-gray" onClick={()=>setOpen(false)}>Cancel</button>
          <button className="btn btn-blue" onClick={save}>{editId ? 'Update' : 'Create'}</button>
        </>}>
        <div className="form-grid">
          <div className="form-group"><label>Product Name *</label><input value={form.name} onChange={e=>setForm({...form, name:e.target.value})}/></div>
          <div className="form-group"><label>Category</label>
            <select value={form.category_id||''} onChange={e=>setForm({...form, category_id:e.target.value})}>
              <option value="">-- Select --</option>
              {cats.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="form-group"><label>Unit</label>
            <select value={form.unit} onChange={e=>setForm({...form, unit:e.target.value})}>
              <option>PCS</option><option>KG</option><option>LTR</option><option>MTR</option><option>BOX</option><option>TON</option><option>BAG</option><option>DOZ</option>
            </select>
          </div>
          <div className="form-group"><label>HSN Code</label><input value={form.hsn_code} onChange={e=>setForm({...form, hsn_code:e.target.value})}/></div>
          <div className="form-group"><label>Tax Rate %</label><input type="number" value={form.tax_rate} onChange={e=>setForm({...form, tax_rate:e.target.value})}/></div>
          <div className="form-group"><label>Purchase Price</label><input type="number" value={form.purchase_price} onChange={e=>setForm({...form, purchase_price:e.target.value})}/></div>
          <div className="form-group"><label>Selling Price</label><input type="number" value={form.selling_price} onChange={e=>setForm({...form, selling_price:e.target.value})}/></div>
          <div className="form-group"><label>Stock Qty</label><input type="number" value={form.stock_qty} onChange={e=>setForm({...form, stock_qty:e.target.value})}/></div>
          <div className="form-group"><label>Min Stock Level</label><input type="number" value={form.min_stock} onChange={e=>setForm({...form, min_stock:e.target.value})}/></div>
          <div className="form-group full-width"><label>Description</label><textarea value={form.description} onChange={e=>setForm({...form, description:e.target.value})}/></div>
        </div>
      </Modal>
    </div>
  );
}
